import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';

export default class Modalcertificate extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   send_comment1:"",

   filecomment1:null,

   id_sendcf:"",
   namepresentcf:"",
   send_namecf:"",
   branchcf:"",
   awardcf:""
}


this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleChange4 = this.handleChange4.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
//this.getExpert = this.getExpert.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectat();
}


 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
      this.setState({ id_sendcf:this.props.id_send,
                      branchcf:this.props.branchcf
                    })
  }

 
  handleChange2(event) {    this.setState({namepresentcf: event.target.value});  }
  handleChange3(event) {    this.setState({send_namecf: event.target.value});  }
  handleChange4(event) {    this.setState({awardcf: event.target.value});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idsend", this.props.id_send);
      datafrm.append("namepresentcf", this.state.namepresentcf);
      datafrm.append("send_namecf", this.state.send_namecf);
      datafrm.append("branchcf", this.state.branchcf);
      datafrm.append("awardcf", this.state.awardcf);
      
  Axios.post("https://conference.kpru.ac.th/PHPAPI/insertcertificate.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })


   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }


    if (res.status = 200) {
      message.success("บันทึกข้อมูลสำเร็จ")
      this.toggle()
     // window.location.href = '/adminfaculty'
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }
  })



 
}, 2000);

  //this.props.updateat();
  //this.getExpert()
  //window.location.href = '/adminconference-sd/superadminstatus'

  }


    render() {
        
        return (
            <MDBContainer>
            <MDBBtn color="primary" onClick={this.toggle} size="sm"><MDBIcon icon="certificate" /> จัดการเกียรติบัตร</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle} className="text-left">ชื่อเรื่องเดิม :{this.props.namearticla} </MDBModalHeader>
              <MDBModalBody>
              <div>

              <p className="text-left">ชื่อเรื่อง (แสดงในเกียรติบัตร) </p>   
              <MDBInput type="textarea" label="ชื่อเรื่อง" value={this.state.value} onChange={this.handleChange2} outline  />
              <p className="text-left">ชื่อผู้นำเสนอ (แสดงในเกียรติบัตร)</p>   
              <MDBInput type="textarea" label="ชื่อผู้นำเสนอ" value={this.state.value} onChange={this.handleChange3} outline />
              <p className="text-left">รางวัลที่ได้รับ </p>   
              <MDBInput type="textarea" label="รางวัล" value={this.state.value} onChange={this.handleChange4} outline />
        
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
